<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee">
            <div class="top-container">
                <div @click="gotoPage('order')" class="cart-container">
                    <img
                        id="menu-gotoorder-btn"
                        class="top-button"
                        src="@/assets/home/order_icon.svg"
                    />
                </div>
                <img
                    class="title_logo"
                    src="@/assets/home/logo-new-theme.png"
                />
                <div
                    v-if="menuFunction"
                    @click="purchaseItem"
                    class="cart-container"
                >
                    <img
                        v-if="isEmpty"
                        id="menu-gotocart-btn"
                        class="top-button"
                        src="@/assets/home/empty_cart.svg"
                    />
                    <img
                        v-else
                        id="menu-gotocart-btn"
                        class="top-button"
                        src="@/assets/home/cart_icon.svg"
                    />
                    <span v-if="!isEmpty" class="cart-amount">{{
                        cartCount
                    }}</span>
                </div>
                <div v-else class="cart-container">
                    <div class="dummy-dot">.</div>
                </div>
            </div>
            <!-- temporary close -->
            <LocationDropdown path="menu" />
            <div class="carousel-container">
                <Carousel :apiConfig="'nescafestreetcafe_menu'" />
            </div>
            <!-- temporary close -->
            <div class="tabbar-container">
                <ul
                    class="tabbar-list"
                    v-for="(item, index) in tabBar"
                    :key="index"
                >
                    <li
                        @click="changeTabBar(item.name)"
                        class="tabbar-item"
                        :class="{ active: activeTab === item.name }"
                    >
                        <img
                            class="item-image"
                            :src="require(`../../../assets/home/${item.image}`)"
                        />
                        <div class="item-name">
                            {{ item.name }}
                        </div>
                    </li>
                </ul>
            </div>
            <div v-if="activeTab === 'เมนู'" class="mainmenu-container">
                <div class="category-slider-container">
                    <category-slider
                        ref="categoryslider"
                        :locale="locale"
                        :categoryConfig="categoryConfig"
                        :busEvent="busCategory"
                        @changeCategory="changeCategory($event)"
                    >
                    </category-slider>
                </div>
                <div class="categories-list-container">
                    <menu-list
                        ref="campaignlist"
                        :isLoading="isLoading"
                        :initListConfig="campaignListConfig"
                        :initFilterConfig="campaignListFilterConfig"
                        :busEvent="busCategory"
                        :menuFunction="menuFunction"
                        @toggleLoading="toggleLoading($event)"
                    >
                    </menu-list>
                </div>
            </div>
            <div v-if="activeTab === 'สมาชิกของฉัน'" class="mainmenu-container">
                <div class="categories-list-container">
                    <subscription-list
                        :categoryConfig="subscriptionConfig"
                        :busEvent="busCategory"
                        @toggleLoading="toggleLoading($event)"
                    />
                </div>
            </div>
            <Footer :settabactive="'menu'" />
        </div>
        <b-modal
            id="locationAlert"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="success-main">
                <div
                    id="menudetail-successmodule-close-btn"
                    class="close-btn"
                    @click="$bvModal.hide('locationAlert')"
                >
                    <img src="@/assets/profile/close-new.svg" alt="" />
                </div>
                <div class="success-header">
                    <div class="title-scc">
                        <h2>กรุณาเลือกสาขา</h2>
                        <p>กรุณาเลือกสาขา Nescafe Street Cafe ใกล้คุณ</p>
                    </div>
                </div>
                <div
                    id="menudetail-successmodule-confirm-btn"
                    class="success-btn"
                    @click="$router.push('/cafemap/menu')"
                >
                    ตกลง
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from "vue";
// helper //
import Locale from "@/helper/locale/locale.js";
// component //
import Footer from "@/components/Footer/Footer.vue";
import Carousel from "@/module/Menu/component/Carousel.vue";
import MenuList from "@/module/Menu/component/MenuList.vue";
import SubscriptionList from "@/module/Menu/component/SubscriptionList.vue";
import CategorySlider from "../component/CategorySlider.vue";
import LocationDropdown from "@/components/Input/LocationDropdown.vue";
// core //
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder,
} from "@/core/Campaign/model/CampaignConfigModel.js";
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";
import ConfigManager from "@/config/ConfigManager.js";
import Mixin from "@/mixin/Mixin";
import BzbsCart from "@/core/Cart/service/BzbsCart.js";
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
//helper//
import CacheHelper from "@/helper/CacheHelper.js";
//vuex
import { mapGetters } from "vuex";

export default {
    name: "Menu",
    components: {
        Footer,
        Carousel,
        MenuList,
        SubscriptionList,
        CategorySlider,
        LocationDropdown,
    },
    mixins: [Mixin],
    props: {},
    data: function () {
        return {
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),
            isLoading: false,
            //config
            categoryConfig: {},
            campaignListConfig: {},
            campaignListFilterConfig: {},
            subscriptionConfig: {},

            busCategory: new Vue(),
            tabBar: [
                { name: "เมนู", image: "menu_icon.svg" },
                { name: "สมาชิกของฉัน", image: "subscription_icon.svg" },
            ],
            activeTab: "เมนู",

            cartCount: 0,
            userToken: null,
            cacheHelper: new CacheHelper(),

            nameArray: [],
            filterArray: [],
            markers: [],
            getCallback: false,

            menuFunction: true,
            isEmpty: true,
        };
    },
    created: function () {
        this.userToken = this.cacheHelper.getCache("BzbsUser").token;
        this.handleLoading(true);
        this.getCartQty();
        this.initialCategory();
        this.getBlob();
    },
    computed: mapGetters(["getLocationStore"]),
    methods: {
        getBlob() {
            const url =
                "/nestle/nescafe_streetcafe/custom/config_close_function.json";
            return new Promise((resolve, reject) => {
                BzbsCustom.apiGetCustom(url)
                    .then((response) => {
                        // console.log(response);
                        this.menuFunction = response.menuDetailFunction;
                        if (!response.tabMenu) {
                            this.tabBar = [
                                { name: "เมนู", image: "menu_icon.svg" },
                            ];
                        }
                        // console.log(this.menuFunction);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        initialCategory() {
            return new Promise((resolve) => {
                var configStr = ConfigManager.getCategoryMenu();
                var categoryConfig = new CategoryConfigBuilder()
                    .setConfig(configStr)
                    .setLocale(this.locale);

                var configSubScriptionStr = ConfigManager.getSubscriptionMenu();
                var subscriptionConfig = new CategoryConfigBuilder()
                    .setConfig(configSubScriptionStr)
                    .setLocale(this.locale);

                this.categoryConfig = categoryConfig.create();
                this.subscriptionConfig = subscriptionConfig.create();

                resolve(this.categoryConfig);
            });
        },
        orderCafeName() {
            for (let i = 0; i < this.markers.length; i++) {
                this.nameArray.push([
                    this.markers[i].name,
                    parseInt(this.markers[i].distance),
                    this.markers[i].position.lat,
                    this.markers[i].position.lng,
                ]);
            }
            this.nameArray.sort((a, b) => {
                return a[1] > b[1] ? 1 : -1;
            });
            this.filterArray = this.nameArray[0];
            this.setLocation({
                location: this.filterArray[0],
                lat: this.filterArray[2],
                lng: this.filterArray[3],
            });
        },
        initialCampaign: function (category) {
            return new Promise((resolve) => {
                this.campaignListConfig = {};
                this.campaignListFilterConfig = {};

                var listConfig = new CampaignListConfigBuilder()
                    .setConfigList(category.list_config)
                    .setTop(25);

                if (category.id) listConfig.setCatId(category.id);

                this.campaignListConfig = listConfig.create();

                var filterConfig = new CampaignListFilterConfigBuilder();
                this.campaignListFilterConfig = filterConfig.create();

                this.busCategory.$emit("reInitList", {
                    listConfig: this.campaignListConfig,
                    filterConfig: this.campaignListFilterConfig,
                });
                resolve(this.campaignListFilterConfig);
            });
        },
        purchaseItem() {
            if (this.getLocationStore.location) {
                let locale = Locale.getLocaleCode();
                let urlLocation = window.location.origin;
                let urlBack = urlLocation + "/menu";
                let urlOrder = urlLocation + "/order";
                window.location.replace(
                    ConfigManager.getApiShoppingUrl() +
                        "/nescafestreetcafe?theme=nescafestreetcafe" +
                        "&token=" +
                        this.userToken +
                        "&locale=" +
                        locale +
                        "&return_url=" +
                        urlBack +
                        "&myorder_url=" +
                        urlOrder +
                        "&lat=" +
                        this.getLocationStore.lat +
                        "&lng=" +
                        this.getLocationStore.lng +
                        "&locationId=" +
                        "" +
                        "&api=stgnsc2"
                );
            } else {
                this.$bvModal.show("locationAlert");
            }
        },
        getCartQty() {
            BzbsCart.apiGetCartCount(this.userToken).subscribe(
                (res) => {
                    this.cartCount = res.cart_count;
                    if (this.cartCount !== 0) {
                        this.isEmpty = false;
                    }
                },
                (err) => {
                    console.log(err);
                }
            );
        },
        changeCategory: function (category) {
            this.handleLoading(true);
            this.initialCampaign(category).then(() => {
                if (this.activeTab === "เมนู") {
                    this.$refs.campaignlist.getList().then(() => {
                        this.handleLoading(false);
                    });
                } else {
                    this.$refs.subscriptionlist.getList().then(() => {
                        this.handleLoading(false);
                    });
                }
            });
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
        changeTabBar: function (tabName) {
            this.activeTab = tabName;
        },
        gotoPage: function (route) {
            this.$router.push(route);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Menu/style/mission.scss";
$primary-color: rgb(111, 105, 99);
$secondary-color: rgb(167, 144, 123);
h4,
p {
    margin: 0;
}

.main-layout {
    overflow: auto;
    .carousel-container {
        position: relative;
        margin: 0;
    }
    .mainmenu-container {
        padding-bottom: 90px;
    }
}
.tabbar-container {
    display: flex;
    margin: 15px 20px;
    justify-content: center;
    gap: 16px;
    .tabbar-list {
        list-style: none;
        padding: 0;
        .tabbar-item {
            background-color: rgba(167, 144, 123, 0.3);
            margin: 1px solid #a7907b;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100px;
            min-height: 70px;
            padding: 5px;
            .item-image {
                height: 27px;
                margin-bottom: 5px;
            }
            .item-name {
                color: #fff;
                font-size: 14px;
                text-align: center;
            }

            &.active {
                background-color: $color-text;
            }
        }
    }
}
.modal-content {
    .success-main {
        .close-btn {
            float: right;
        }
        .success-header {
            .title-scc {
                h2 {
                    color: $light-brown;
                    text-align: center;
                    font-size: 18px;
                    margin-bottom: 1.5rem;
                    font-family: "PromptSemiBold";
                }
                p {
                    color: #000;
                    text-align: center;
                    font-size: 16px;
                    margin-bottom: 1.5rem;
                    padding: 0 50px;
                }
            }
        }
        .success-btn {
            text-align: center;
            color: #fff;
            background: $dark-brown;
            padding: 0;
            border-radius: 40px;
            font-size: 1rem;
            height: 45px;
            line-height: 45px;
        }
    }
}
//need to remove in future
.subscription_container {
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .subscription_item {
        margin-bottom: 15px;
        .subscription_image {
            height: 160px;
        }
    }
}
</style>
